import { initContract } from '@ts-rest/core'
import { z } from 'zod'

const c = initContract()
const prefix = '/v2/playground'

export const TemplateInfoSchema = z.object({
  relativePath: z.string(),
  brand: z.string(),
  customer: z.string().nullable(),
  templateType: z.string(),
  extension: z.string(),
})

export const playground = c.router({
  listTemplates: {
    method: 'GET',
    path: `${prefix}/templates`,
    responses: {
      200: z.array(TemplateInfoSchema),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'List all email templates',
  },
  renderTemplate: {
    method: 'POST',
    path: `${prefix}/templates/render`,
    body: z.object({
      relativePath: z.string(),
    }),
    responses: {
      200: z.object({
        html: z.string(),
        imagePlaceholders: z.array(z.string()),
      }),
      400: z.object({ message: z.string() }),
      401: z.object({ message: z.string() }),
      500: z.object({ message: z.string() }),
    },
    summary: 'Render an email template with mock data',
  },
})
